import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';

import { EstablecimientoForm } from '@/features/establecimientos/components/EstablecimientoForm';
import { useCreateEstablecimiento } from '@/features/establecimientos/hooks/useEstablecimientos';
import type { EstablecimientoFormValues } from '@/features/establecimientos/schemas';
import type { CanalEnvio } from '@/types/enums';

interface CrearEstablecimientoDialogProps {
  open: boolean;
  uidProfesional?: string;
  onCreated: (uid: string) => void;
  onCancel: () => void;
}

export function CrearEstablecimientoDialog({
  open,
  uidProfesional,
  onCreated,
  onCancel,
}: CrearEstablecimientoDialogProps): JSX.Element {
  const mutation = useCreateEstablecimiento();

  async function handleSubmit(values: EstablecimientoFormValues): Promise<void> {
    const facturacion = values.facturacion;
    const created = await mutation.mutateAsync({
      nombre: values.nombre,
      firma_ganaderos: values.firma_ganaderos || null,
      localidad: values.localidad || null,
      uid_profesional_actual: values.uid_profesional_actual,
      facturacion:
        facturacion.cuit ||
        facturacion.razon_social ||
        facturacion.email_facturacion ||
        facturacion.telefono_whatsapp_facturacion ||
        facturacion.envio_factura
          ? {
              cuit: facturacion.cuit || null,
              razon_social: facturacion.razon_social || null,
              email_facturacion: facturacion.email_facturacion || null,
              telefono_whatsapp_facturacion:
                facturacion.telefono_whatsapp_facturacion || null,
              envio_factura: (facturacion.envio_factura || null) as CanalEnvio | null,
            }
          : null,
      telefonos_contacto: (values.telefonos_contacto ?? [])
        .filter((t) => t.numero.trim())
        .map((t) => ({ numero: t.numero, nombre: t.nombre?.trim() || null })),
    });
    onCreated(created.uid_establecimiento);
  }

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="md">
      <DialogTitle>Nuevo establecimiento</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <EstablecimientoForm
            mode="create"
            defaultValues={uidProfesional ? { uid_profesional_actual: uidProfesional } : undefined}
            onSubmit={(v) => void handleSubmit(v)}
            onCancel={onCancel}
            submitLabel="Crear establecimiento"
            submitting={mutation.isPending}
            error={mutation.error}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
